module.exports = {
	"base": {
		"welcome": "Добре дошли в Mulligans, %{name}.",
		"user": "Информация за потребителя",
		"devices": "Устройства",
		"refunds": "Възстановяване на средства",
		"resources": "Източници",
		"transactions": "Транзакции и възстановяване на средства",
		"email": "Имейл",
		"password": "Парола",
		"save": "Запиши",
		"sign-out": "Излизане",
		"cancel": "Отказ",
		"close": "Затвори",
		"learn-more": "Научете повече",
		"required": "Задължително",
		"support": "Поддръжка",
		"bookshelf": "Bookshelf",
		"launch": "Пусни",
		"download": "Изтегли",
		"details": "По-подробно",
		"cannot-be-blank": "%{field} не може да бъде празно.",
		"saving": "Записва се...",
		"done": "Готово",
		"failed": "Неуспешно",
		"copy": "Копирай"
	},
	"signin": {
		"login-failure": "Имейл адресът или паролата са неправилни",
		"welcome-large": "Добре дошли в <span class='inner'>центъра за профили на %{brand} </span>",
		"welcome-small": "<span class='inner'>Център за профили</span>",
		"signin-button": "Влизане",
		"forgot-password": "Забравена парола",
		"new-to-vst": "Нови ли сте в %{brand}?",
		"create-account": "Създайте си профил",
		"signing-in": "Влизане...",
		"signin-failed": "Неуспешно влизане"
	},
	"transactions": {
		"price": "Цена",
		"excluded": "(Без данъка)",
		"quantity": "Количество",
		"confirmation#": "Потвърждение №",
		"payment": "Плащане",
		"purchased": "Купени",
		"purchase-details": "Данни за покупката",
		"subtotal": "Междинна сума",
		"total": "Обща сума",
		"tax": "Данък",
		"loading": "Здравей потребителю, ние зареждаме вашите транзакции...",
		"no-purchases": "Вие нямате покупки.",
		"seller-vat": "ДДС на продавача",
		"total-vat": "Общо платено %{vat}",
		"portion": "%{subTax} Данък %{rate}%",
		"vat-disclosure": "Цената включва %{vat}",
		"purchases": "Покупки",
		"refunded-items": "Възстановени артикули",
		"book-title": "Заглавие на книга ",
		"refund-details": "Данни за възстановяването",
		"print-receipt": "Отпечатване на разписка",
		"request-refund": "Заявете възстановяване",
		"expired": "Изтекъл",
		"expires-in": "Изтича на %{date}",
		"details-refund": "Детайли и възстановяване на средства",
		"modal": {
			"cant-refund-title": "Възстановяването е недостъпно",
			"cant-refund": "Средствата за книгата ви не може да бъдат възстановени поради една или повече от следните причини.",
			"cant-refund-1": "Твърде много съдържание от вашата книга е било разгледано.",
			"cant-refund-2": "Изминали са повече от 14 дни от датата на покупката.",
			"cant-refund-3": "Вашият код за онлайн ресурси е бил разкрит.",
			"cant-refund-4": "Преди време са ви възстановявани средства за тази книга.",
			"cant-refund-5": "Всички кодове вече са предявени и/или средствата по тях са възстановени.",
			"cant-refund-6": "Изминали са повече от 30 дни от датата на покупката.",
			"cant-refund-support": "Ако все още не сте сигурни в правилата за възстановяване на средства от %{brand}, свържете се с <a href='%{support_url}' target='_blank'>поддръжката</a>."
		},
		"license": {
			"perpetual": "Онлайн достъпът няма дата на изтичане",
			"days": "%{days}-дневен достъп"
		}
	},
	"devices": {
		"description": "%{brand} ви позволява да имате <span>%{desktop}</span> компютъра и <span>%{mobile}</span> мобилни устройства/таблета, които да са активирани във всеки един момент.",
		"loading": "Здравейте, ние регистрираме вашите устройства:)",
		"no-active": "Нямате активни устройства.",
		"deactivate": "Деактивирай"
	},
	"user": {
		"personal-information": "Лични данни",
		"security-information": "Информация за сигурността",
		"notifications": "Известия",
		"first-name": "Собствено име",
		"last-name": "Фамилно име",
		"change-password-title": "Смяна на паролата",
		"current-password": "Текуща парола",
		"new-password": "Нова парола",
		"security-password": "Парола",
		"confirm-new-password": "Повторете новата парола",
		"security-question": "Въпрос за сигурност",
		"security-info-change": "Промяна",
		"question": "Въпрос",
		"answer": "Отговор",
		"notifications-text": "Изпращайте ми информация по имейла за промени в активността на профила ми, актуализации на продукти, както и специални предложения.",
		"loading": "Спот извлича вашата потребителска информация, моля изчакайте малко 🐶",
		"change-password-text": "Паролата трябва да съдържа най-малко осем знака, да има поне една главна буква, една малка буква и един специален символ.",
		"email-locked": "Имейлът е заключен",
		"email-locked-description": "Вие нямате необходимия достъп, за да промените имейла си.",
		"email-locked-more": "Моля, свържете се с администратора",
		"security-question6": "Кой е любимият ви спорт?",
		"security-question7": "Кой е любимият ви вид сладолед?",
		"security-question8": "Как е името на домашния ви любимец?",
		"security-question9": "Като малък какъв искахте да станете?",
		"security-question10": "Какво беше фамилното име на любимия ви учител?",
		"new-password-failure": "Парола не отговаря на изискванията",
		"confirm-password-failure": "Паролите трябва да съвпадат",
		"new-password-tooltip": "Трябва да съдържа поне 8 символа, главна буква, малка буква и специален знак.",
		"enter-valid-email": "Моля въведете валиден имейл адрес.",
		"password-cannot-be-same": "Паролата не може да бъде същата като предишната парола",
		"incorrect-password": "Грешна парола",
		"complete-account": "Изглежда, че трябва да <a href='%{href}'>завършите своя акаунт</a>.",
		"completing-allows": "Завършването на вашия акаунт ще ви позволи да четете книги офлайн в нашите мобилни приложения и да споделяте бележки и маркирания с приятели.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Спомагателни",
		"access-codes": "Кодове за достъп",
		"print-on-demand": "Печат пo поръчка",
		"check-pod": "Проверете опциите за издателски печат на вашите книги.",
		"check-now": "Провери сега",
		"loading": "Моля изчакайте, ние актуализираме вашите ресурси!",
		"in": "в",
		"access-code-intro": "Кодът за достъп е паролата, която използвате за достъп до съдържанието на онлайн курса. След като разкриете кода за даден продукт, няма да можете да го върнете. За повече инструкции относно това как да използвате кодовете за достъп, посетете <a href='%{support_url}' target='_blank'>Поддръжка</a>.",
		"expires": "Изтича на",
		"expiration-message": "Съдържа инструкции как да използвате кода си за достъп.",
		"copy-fail": "Не може да се копира. Моля, изберете кода и ръчно го копирайте.",
		"launch-site": "Пускане на сайта",
		"launch-book": "Стартирай книгата",
		"reveal-code": "Разкрий кода",
		"no-resources": "Вие нямате никакви ресурси.",
		"no-access-codes": "Вие нямате никакви кодове за достъп.",
		"no-ancillaries": "Няма спомагателни средства за това заглавие",
		"name": "Име",
		"type": "Тип",
		"size": "Размер",
		"download-all": "Изтегли всички",
		"back": "Назад към ресурсите"
	},
	"refunds": {
		"states": {
			"refunded": "С възстановени средства",
			"unavailable": "Възстановяването е недостъпно"
		},
		"reasons": {
			"dropped": "Напуснах курса",
			"wrong": "Това не беше правилната книга за моя курс",
			"print": "Реших да си купя печатно издание вместо това",
			"missing": "Книгата не съдържа всичко, което ми трябва за моя курс (напр. компактдиск, уеб достъп, видео)",
			"other": "Друго"
		},
		"bulk": {
			"policy": "С натискането на бутона &quot;Завърши възстановяването&quot; по-долу аз съм се съгласявам с правилата на %{brand}  <a href='%{policy_url}' target='_blank'>за възстановяване </a>.",
			"complete": "Завърши възстановяването",
			"view-details": "Покажи данни за възстановяването",
			"success": "Вашата заявка за възстановяване на средства е подадена. Моля, изчакайте 48 часа за обработка.",
			"failure": "Съжаляваме – нещо се обърка! Възстановяването на средствата не се осъществи.",
			"retry": "Опитайте пак",
			"support": "Свързване с поддръжката",
			"available-codes": "Налични кодове",
			"codes-selected": "Избрани кодове",
			"download": "Изтегляне на кодове",
			"partially-refunded": "Частично възстановени",
			"pick-one": "Трябва да изберете поне един код, за да извърши възстановяване на средства"
		},
		"refund": "Възстановяване",
		"all": "Всички ли да се възстановят?",
		"missing-reason": "Трябва да изберете причина, за да продължите",
		"missing-elaboration": "Моля, прецизирайте",
		"policy": "С натискането на бутона \"Изпълни заявката за възстановяване\" по-долу аз разбирам, че ако купя този електронен учебник (eTextbook) от %{brand} отново, няма да имам право да поискам последващо възстановяване на средствата за същия електронен учебник. Вижте пълния списък на правилата за връщане.",
		"refunded": "С възстановени средства",
		"sorry": "Съжаляваме, че не сте доволни от покупката си.",
		"error": "Нещо се обърка",
		"error-explain": "Не успяхме да обработим възстановяването на средствата ви. Моля, опитайте отново.",
		"why": "Кажете ни защо?",
		"no-refunds": "Вие нямате продукти с възстановени средства.",
		"select-codes": "Изберете код(ове) за възстановяване:",
		"number": "Колко?",
		"back": "Назад към възстановяването"
	},
	"purchases": {
		"back": "Назад към покупките"
	},
	"global-bar": {
		"account": "Настройки на профила"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/bg.json
 ** module id = 970
 ** module chunks = 0
 **/